import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"

export const autoEuropeProviderNormalizationDrawerData = signal({})
export const autoEuropeProviderNormalizationDrawerErrors = signal({})
export const autoEuropeProviderNormalizationListData = signal([])
export const autoEuropeProviderNormalizationIsLoading = signal(false)
export const autoEuropeProviderNormalizationIsSubmitting = signal(false)

export const isAutoEuropeProviderNormalizationDrawerOpen = computed(() => autoEuropeProviderNormalizationDrawerData.value && !isEmpty(autoEuropeProviderNormalizationDrawerData.value))

export const autoEuropeProviderNormalizationFilterMode = signal('any')
export const autoEuropeProviderNormalizationFilterMarkets = signal([])
export const autoEuropeProviderNormalizationFilterOfficeCountries = signal([])

export const clearAutoEuropeProviderNormalizationSignals = () => batch(() => {
	autoEuropeProviderNormalizationDrawerData.value = {}
	autoEuropeProviderNormalizationDrawerErrors.value = {}
})
